/* script */










































































import Vue from 'vue'
import $ from 'jquery'
import IndustrySmallSectorSelectionForm from '../containers/IndustrySmallSectorSelectionForm.vue'
import PrefectureSelection from './PrefectureSelection.vue'

const __vue_script__ = Vue.extend({
  components: {
    PrefectureSelection,
    IndustrySmallSectorSelectionForm,
  },
  props: {
    hasSelectedToas: {
      type: Boolean,
      required: true,
    },
    baseSearchUrl: {
      type: String,
      required: true,
    },
    business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      query: '',
      newPrefectureIds: [],
      transactionValueMin: null,
      acquisitionTrackRecord: null,
      unlisted: false,
      exceptInvestimentCompany: false,
      showModal: false,
      industrySmallSectorIds: [] as number[],
      submitting: false,
    }
  },
  computed: {
    atrOptions(): Array<Record<string, any>> {
      return [
        { value: null, text: '' },
        { value: 'yes', text: '買収実績有り' },
        { value: 'no', text: '買収実績無し' },
      ]
    },
    searchUrl(): string {
      const data = {
        'q[query]': this.query,
        'q[except_investiment_company]': this.exceptInvestimentCompany ? '1' : '0',
        'q[acquisition_track_record]': this.acquisitionTrackRecord || '',
        'q[unlisted]': this.unlisted ? '1' : '0',
        'q[transaction_value_min]': this.transactionValueMin || '',
      }
      const params = new URLSearchParams(data)
      this.newPrefectureIds.forEach((prefectureId) =>
        params.append('q[prefecture_ids][]', prefectureId),
      )
      this.industrySmallSectorIds.forEach((id) =>
        params.append('q[industry_small_sector_ids][]', String(id)),
      )
      return `${this.baseSearchUrl}?${params.toString()}`
    },
  },
  created() {
    this.newPrefectureIds = this.business.prefectureIds
    this.transactionValueMin = this.business.transactionValueMin
    this.industrySmallSectorIds = this.business.industrySmallSectorIds || []
  },
  methods: {
    onOpenModalClicked(): void {
      if (!this.hasSelectedToas) {
        this.showModal = true
      } else if (window.confirm('現在選択されているニーズはリセットされます。よろしいですか？')) {
        this.showModal = true
      }
    },
    onChangeIndustrySmallSectors(ids: number[]): void {
      this.industrySmallSectorIds = ids
    },
    onSubmit(): void {
      this.submitting = true
      $.getJSON(this.searchUrl).done((response) => {
        this.$emit('change:toas', response, this.searchUrl)
        this.showModal = false
        this.submitting = false
      })
    },
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-btn",
        {
          staticClass: "m-1",
          attrs: {
            variant: "outline-primary",
            "data-test-id": "search_modal_button",
          },
          on: { click: _vm.onOpenModalClicked },
        },
        [
          _c("i", { staticClass: "fal fa-search-plus" }),
          _vm._v(" 絞り込む\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-form",
        { on: { submit: _vm.onSubmit } },
        [
          _c(
            "b-modal",
            {
              attrs: { "hide-footer": "", size: "lg", title: "絞り込み" },
              on: { ok: _vm.onSubmit },
              model: {
                value: _vm.showModal,
                callback: function ($$v) {
                  _vm.showModal = $$v
                },
                expression: "showModal",
              },
            },
            [
              _c(
                "label",
                [
                  _vm._v("\n        キーワード\n        "),
                  _c("b-form-input", {
                    attrs: {
                      placeholder:
                        "追加で絞り込みたいキーワードを選択してください",
                    },
                    model: {
                      value: _vm.query,
                      callback: function ($$v) {
                        _vm.query = $$v
                      },
                      expression: "query",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("industry-small-sector-selection-form", {
                attrs: {
                  "initial-selected-industry-small-sector-ids":
                    _vm.industrySmallSectorIds,
                },
                on: {
                  "change:industry-small-sectors":
                    _vm.onChangeIndustrySmallSectors,
                },
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "12" } },
                    [
                      _c("label", [
                        _vm._v("\n            都道府県\n          "),
                      ]),
                      _vm._v(" "),
                      _c("PrefectureSelection", {
                        model: {
                          value: _vm.newPrefectureIds,
                          callback: function ($$v) {
                            _vm.newPrefectureIds = $$v
                          },
                          expression: "newPrefectureIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "6" } }, [
                    _c(
                      "label",
                      [
                        _vm._v("\n            買収準備金額\n            "),
                        _c(
                          "b-input-group",
                          { attrs: { append: "万円" } },
                          [
                            _c("b-form-input", {
                              attrs: { number: "", type: "number" },
                              model: {
                                value: _vm.transactionValueMin,
                                callback: function ($$v) {
                                  _vm.transactionValueMin = $$v
                                },
                                expression: "transactionValueMin",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "6" } }, [
                    _c(
                      "label",
                      [
                        _vm._v("\n            買収実績\n            "),
                        _c("b-form-select", {
                          attrs: { options: _vm.atrOptions },
                          model: {
                            value: _vm.acquisitionTrackRecord,
                            callback: function ($$v) {
                              _vm.acquisitionTrackRecord = $$v
                            },
                            expression: "acquisitionTrackRecord",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { lg: "6" } },
                    [
                      _c("label", [_vm._v("その他")]),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value: _vm.unlisted,
                            callback: function ($$v) {
                              _vm.unlisted = $$v
                            },
                            expression: "unlisted",
                          },
                        },
                        [_vm._v("\n            非上場企業のみ\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value: _vm.exceptInvestimentCompany,
                            callback: function ($$v) {
                              _vm.exceptInvestimentCompany = $$v
                            },
                            expression: "exceptInvestimentCompany",
                          },
                        },
                        [_vm._v("\n            ファンドを除外\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mx-auto mt-2", attrs: { lg: "6" } },
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: {
                            block: "",
                            variant: "primary",
                            disabled: _vm.submitting,
                            "data-test-id": "search_submit",
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [
                          _c("b-spinner", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.submitting,
                                expression: "submitting",
                              },
                            ],
                            attrs: { small: "", type: "grow" },
                          }),
                          _vm._v("\n            絞り込み\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-74f09b45_0", { source: "label[data-v-74f09b45] {\n  display: block;\n}\n\n/*# sourceMappingURL=BusinessToaSearchModalButton.vue.map */", map: {"version":3,"sources":["app/javascript/src/components/BusinessToaSearchModalButton.vue","BusinessToaSearchModalButton.vue"],"names":[],"mappings":"AAsKA;EACA,cAAA;ACrKA;;AAEA,2DAA2D","file":"BusinessToaSearchModalButton.vue","sourcesContent":["<template>\n  <div>\n    <b-btn\n      class=\"m-1\"\n      variant=\"outline-primary\"\n      data-test-id=\"search_modal_button\"\n      @click=\"onOpenModalClicked\"\n    >\n      <i class=\"fal fa-search-plus\" /> 絞り込む\n    </b-btn>\n    <b-form @submit=\"onSubmit\">\n      <b-modal v-model=\"showModal\" hide-footer size=\"lg\" title=\"絞り込み\" @ok=\"onSubmit\">\n        <label>\n          キーワード\n          <b-form-input\n            v-model=\"query\"\n            placeholder=\"追加で絞り込みたいキーワードを選択してください\"\n          />\n        </label>\n        <industry-small-sector-selection-form\n          :initial-selected-industry-small-sector-ids=\"industrySmallSectorIds\"\n          @change:industry-small-sectors=\"onChangeIndustrySmallSectors\"\n        ></industry-small-sector-selection-form>\n        <b-row>\n          <b-col lg=\"12\">\n            <label>\n              都道府県\n            </label>\n            <PrefectureSelection v-model=\"newPrefectureIds\" />\n          </b-col>\n          <b-col lg=\"6\">\n            <label>\n              買収準備金額\n              <b-input-group append=\"万円\">\n                <b-form-input v-model=\"transactionValueMin\" number type=\"number\"></b-form-input>\n              </b-input-group>\n            </label>\n          </b-col>\n          <b-col lg=\"6\">\n            <label>\n              買収実績\n              <b-form-select v-model=\"acquisitionTrackRecord\" :options=\"atrOptions\"></b-form-select>\n            </label>\n          </b-col>\n          <b-col lg=\"6\">\n            <label>その他</label>\n            <b-form-checkbox v-model=\"unlisted\">\n              非上場企業のみ\n            </b-form-checkbox>\n            <b-form-checkbox v-model=\"exceptInvestimentCompany\">\n              ファンドを除外\n            </b-form-checkbox>\n          </b-col>\n        </b-row>\n        <b-row class=\"mt-4\">\n          <b-col lg=\"6\" class=\"mx-auto mt-2\">\n            <b-btn\n              block\n              variant=\"primary\"\n              :disabled=\"submitting\"\n              data-test-id=\"search_submit\"\n              @click=\"onSubmit\"\n            >\n              <b-spinner v-show=\"submitting\" small type=\"grow\" />\n              絞り込み\n            </b-btn>\n          </b-col>\n        </b-row>\n      </b-modal>\n    </b-form>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue'\nimport $ from 'jquery'\nimport IndustrySmallSectorSelectionForm from '../containers/IndustrySmallSectorSelectionForm.vue'\nimport PrefectureSelection from './PrefectureSelection.vue'\n\nexport default Vue.extend({\n  components: {\n    PrefectureSelection,\n    IndustrySmallSectorSelectionForm,\n  },\n  props: {\n    hasSelectedToas: {\n      type: Boolean,\n      required: true,\n    },\n    baseSearchUrl: {\n      type: String,\n      required: true,\n    },\n    business: {\n      type: Object,\n      required: true,\n    },\n  },\n  data() {\n    return {\n      query: '',\n      newPrefectureIds: [],\n      transactionValueMin: null,\n      acquisitionTrackRecord: null,\n      unlisted: false,\n      exceptInvestimentCompany: false,\n      showModal: false,\n      industrySmallSectorIds: [] as number[],\n      submitting: false,\n    }\n  },\n  computed: {\n    atrOptions(): Array<Record<string, any>> {\n      return [\n        { value: null, text: '' },\n        { value: 'yes', text: '買収実績有り' },\n        { value: 'no', text: '買収実績無し' },\n      ]\n    },\n    searchUrl(): string {\n      const data = {\n        'q[query]': this.query,\n        'q[except_investiment_company]': this.exceptInvestimentCompany ? '1' : '0',\n        'q[acquisition_track_record]': this.acquisitionTrackRecord || '',\n        'q[unlisted]': this.unlisted ? '1' : '0',\n        'q[transaction_value_min]': this.transactionValueMin || '',\n      }\n      const params = new URLSearchParams(data)\n      this.newPrefectureIds.forEach((prefectureId) =>\n        params.append('q[prefecture_ids][]', prefectureId),\n      )\n      this.industrySmallSectorIds.forEach((id) =>\n        params.append('q[industry_small_sector_ids][]', String(id)),\n      )\n      return `${this.baseSearchUrl}?${params.toString()}`\n    },\n  },\n  created() {\n    this.newPrefectureIds = this.business.prefectureIds\n    this.transactionValueMin = this.business.transactionValueMin\n    this.industrySmallSectorIds = this.business.industrySmallSectorIds || []\n  },\n  methods: {\n    onOpenModalClicked(): void {\n      if (!this.hasSelectedToas) {\n        this.showModal = true\n      } else if (window.confirm('現在選択されているニーズはリセットされます。よろしいですか？')) {\n        this.showModal = true\n      }\n    },\n    onChangeIndustrySmallSectors(ids: number[]): void {\n      this.industrySmallSectorIds = ids\n    },\n    onSubmit(): void {\n      this.submitting = true\n      $.getJSON(this.searchUrl).done((response) => {\n        this.$emit('change:toas', response, this.searchUrl)\n        this.showModal = false\n        this.submitting = false\n      })\n    },\n  },\n})\n</script>\n\n<style lang=\"scss\" scoped>\nlabel {\n  display: block;\n}\n</style>\n","label {\n  display: block;\n}\n\n/*# sourceMappingURL=BusinessToaSearchModalButton.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-74f09b45"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/components/BusinessToaSearchModalButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__